import PropertyDemo1Container from "../../components/home/propertyDemo1";

const PropertyDemo1 = () => {
  return <PropertyDemo1Container />;
};

export default PropertyDemo1;
